<template>
  <span class="fts-history-log-display">
    <!-- null, undefined -->
    <span class="fts-text-default fts-font-style-italic" v-if="isEmpty">
      (empty)
    </span>
    <!-- yes / no -->
    <span v-else-if="dataType === 'yesno'">{{ log ? 'Yes' : 'No' }}</span>
    <!-- date, datetime -->
    <span v-else-if="dataType === 'date'">
      {{ formattedDate }}
    </span>
    <!-- location -->
    <span v-else-if="dataType === 'location'">
      <span v-if="log.placeName">
        {{log.placeName}}
      </span>
      <span class="fts-text-default fts-font-style-italic" v-else>
        (undefined)
      </span>
      <span v-if="log.lat && log.lng">
        ({{log.lat}}, {{log.lng}})
      </span>
    </span>
    <!-- image, file, signature -->
    <span v-else-if="dataType === 'file'">
      <a
        :href="getFilePath(log.path)"
        target="_blank"
        class="fts-link-primary"
        v-if="log.path"
      >
        {{log.name}}
      </a>
      <span v-else>
        {{log.name}}
      </span>
    </span>
    <!-- images, files -->
    <template v-else-if="dataType === 'files'">
      <span v-for="(x, xInd) in log" :key="x.id">
        <a
          :href="getFilePath(x.path)"
          target="_blank"
          class="fts-link-primary"
          v-if="x.path"
        >
          {{x.name}}
        </a>
        <span v-else>
          {{x.name}}
        </span>
        <span v-if="xInd + 1 !== log.length">
          ,&nbsp;
        </span>
      </span>
    </template>
    <!-- user -->
    <span v-else-if="dataType === 'user'">
      {{userName(log)}}
    </span>
    <!-- users -->
    <template v-else-if="dataType === 'users'">
      <span v-for="(x, xInd) in log" :key="x.id || xInd">
        {{userName(x)}}
        <span v-if="xInd + 1 !== log.length">
          ,&nbsp;
        </span>
      </span>
    </template>
    <!-- default -->
    <span v-else class="fts-history-log-value-text">{{log}}</span>
  </span>
</template>

<script>
import moment from "moment";
import commons from '../../commons/commons';

export default {
  props: {
    moduleId: [String, Number],
    informationId: String,
    dataType: String,
    log: {}
  },
  methods: {
    moment,
    getFilePath(path) {
      return commons.getFilePath(path, `${this.moduleId}-${this.informationId}`);
    },
    userName(user) {
      if (!user) return '';
      if (typeof user === 'string') return user;
      return user.name || user.value || user.username || '';
    }
  },
  computed: {
    isEmpty() {
      const isEmptyArray = (val) => val && val.length;
      const isEmptyObject = (val) => {
        for(var i in val) return false;
        return true;
      }
      return (
        this.log === null ||
        this.log === undefined ||
        this.log === '' ||
        (commons.isObject(this.log) && isEmptyArray(this.log)) ||
        (commons.isArray(this.log) && isEmptyObject(this.log))
      );
    },
    // Date-only values drop the "12:00 AM"; datetimes show the viewer-local time
    // with a short timezone tag (e.g. "GMT+8"). Rendered in local time, matching
    // how history times have always been shown.
    formattedDate() {
      const m = moment(this.log);
      if (!m.isValid()) return this.log;

      const dateOnly = m.hour() === 0 && m.minute() === 0 && m.second() === 0 && m.millisecond() === 0;
      if (dateOnly) return m.format('ll');

      const offset = m.utcOffset();
      let tz;
      if (offset === 0) {
        tz = 'UTC';
      } else {
        const sign = offset > 0 ? '+' : '-';
        const abs = Math.abs(offset);
        const hours = Math.floor(abs / 60);
        const minutes = abs % 60;
        tz = 'GMT' + sign + hours + (minutes ? ':' + String(minutes).padStart(2, '0') : '');
      }
      return m.format('lll') + ' ' + tz;
    }
  }
}
</script>

<style lang="scss" scoped>
.fts-history-log-display {
  overflow-wrap: break-word;
}
// plain-text values keep their own spaces and line breaks; formatted values
// (date, user, file, location) don't, so template indentation can't leak in
.fts-history-log-value-text {
  white-space: pre-wrap;
}
</style>